<script lang="ts">
  import { getContext, type Snippet } from "svelte";
  import { melt, createDropdownMenu } from "@melt-ui/svelte";
  import { fly } from "svelte/transition";
  import type { SvelteHTMLElements } from "svelte/elements";

  interface Props {
    children?: Snippet;
    transitionY?: number;
  }

  let { children, transitionY = -10, ...rest }: Props & SvelteHTMLElements["div"] = $props();

  const {
    elements: { menu },
    states: { open },
  } = getContext<ReturnType<typeof createDropdownMenu>>("menu");
</script>

{#if $open}
  <div
    {...rest}
    class="menu flex w-auto min-w-40 flex-col gap-1 overflow-hidden rounded-[18px] bg-alpha-600 p-2 text-sm text-mono-000 shadow-border-popover backdrop-blur-sm dark:bg-alpha-200 dark:text-mono-900 {rest.class}"
    {...$menu} use:$menu.action
    transition:fly={{ duration: 120, y: transitionY }}
  >
    <div class="pointer-events-auto">
      {@render children?.()}
    </div>
  </div>
{/if}

<style>
  @reference "#tailwind.css";
  .menu {
    box-shadow:
      0px 1px 2px 0px rgba(0, 0, 0, 0.04),
      0px 16px 24px -12px rgba(0, 0, 0, 0.08);
  }
</style>
